import React, { useEffect, useState } from "react";
import axios from "axios";

import QuotesList from "./QuotesList";

const AllQuotes = () => {

  const [quotes, setQuotes] = useState([]);
  const [total, setTotal] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [perPage, setPerPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);

  const [loading, setLoading] = useState(false);

  const fetchQuotes = async (pageNumber) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STOIC_QUOTES}?page=${pageNumber}&limit=18`
      );
      setQuotes(response.data.results);
      setTotal(response.data.total_results);
      setTotalPages(response.data.total_pages);
      setPerPage(response.data.per_page);
      setCurrentPage(response.data.page);
      setLoading(false);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    fetchQuotes(1);
  }, []);

  return (
    <div>
      <QuotesList
        quotes={quotes}
        total={total}
        totalPages={totalPages}
        perPage={perPage}
        currentPage={currentPage}
        fetchQuotes={fetchQuotes}
        loading={loading}
        allquotes={true}
      />
    </div>
  );
};

export default AllQuotes;
